import { Utils } from "@/plugins/utils";
import router from "@/router";

export default {
	namespaced: true,
	state: {
		lstCf6: [],
		cf6: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	actions: {
		initForm({ commit }) {
			commit("initForm");
		},
		async get({ dispatch }, cf6repres){
			return await this._vm.$axios.get(`/Representative/Representative/Find/${cf6repres}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find({ commit, dispatch}, cf6repres){
			commit("setLoading", true);
			commit("initForm")
			let payload = await dispatch("get", cf6repres)
			.then(cf6 => {
				commit("setCf6", cf6)
				return cf6
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red", 
					text: error.message
				}, { root: true })
			});
			commit("setLoading", false);
			return payload;
		},
		save({ dispatch, getters }) {
			let cf6 = getters.getCf6
			if (!cf6.cf6forms){
				cf6.cf6forms = 0
			}
			if (getters.getUpdate) {
				return dispatch("update", cf6);
			}
			return dispatch("insert", cf6);
		},
		async insert({ dispatch, commit }, cf6) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Salvando",
					indeterminate: true,
				},
				{ root: true }
			);
			let payload = await this._vm.$axios
				.post("/Representative/Representative/Insert", cf6)
				.then((response) => {
					Utils.ValidateAxiosResponse(response.data);
					commit("setCf6", null);
					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);
			return payload;
		},
		async update({ dispatch, commit }, cf6) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Salvando",
					indeterminate: true,
				},
				{ root: true }
			);
			let payload = await this._vm.$axios
				.put("/Representative/Representative/Update", cf6)
				.then((response) => {
					Utils.ValidateAxiosResponse(response.data);
					commit("setCf6", null);
					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);
			return payload;
		},
		async exportAllRepresentatives({ dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Exportando",
					indeterminate: true,
				},
				{ root: true }
			);

			let payload = await this._vm.$axios
				.put(`/Representative/Representative/ExportAllRepresentatives`)
				.then((response) => {
					Utils.ValidateAxiosResponse(response.data);
					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);

			return payload;
		},

		async exportRepresentative({ dispatch }, cf6repres) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Exportando",
					indeterminate: true,
				},
				{ root: true }
			);

			let payload = await this._vm.$axios
				.put(`/Representative/Representative/ExportRepresentative/${cf6repres}`)
				.then((response) => {
					Utils.ValidateAxiosResponse(response.data);
					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);

			return payload;
		},
		async changePassword({ dispatch, commit }, cf6, ) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Alterando senha",
					indeterminate: true,
				},
				{ root: true }
			);
			let payload = await this._vm.$axios
				.put("/Representative/Representative/ChangeRepresentativePassword", cf6 )
				.then((response) => {
					Utils.ValidateAxiosResponse(response.data);
					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);
			return payload;
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Excluindo",
					indeterminate: true,
				},
				{ root: true }
			);
			let payload = await this._vm.$axios
				.delete(
					`/Representative/Representative/Delete/${getters.getCf6.cf6repres}`
				)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);

			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true);
			commit("initForm");
			await this._vm.$axios
				.get(
					`/Representative/Representative/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`
				)
				.then((response) => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("setParamsDataTable", payload);
				})
				.catch((error) => {
					commit("setCf6", null);
					commit("setSearch", "");
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
				});
			commit("setLoading", false);
		},
		async findAllWithLastRepres({ dispatch }, { field, text, moreFilters, cf1cliente }) {
			let queryMoreFilters = "";
			moreFilters.forEach((moreFilter) => { queryMoreFilters += `&moreFilters=${moreFilter}`;});
			if (!cf1cliente) {
				cf1cliente = "";
			}
			return await this._vm.$axios
				.get(
					`/Representative/Representative/FindAllWithLastRepres?cf1cliente=${cf1cliente}&field=${field}&text=${text}${queryMoreFilters}`
				)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
		async findLastByCustomer({ dispatch }, cf1cliente) {
			return await this._vm.$axios
				.get(
					`/Representative/Representative/FindLastByCustomer/${cf1cliente}`
				)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return null;
				});
		},
		async printReportInvoicingRanking({ dispatch }, params) {
			dispatch(
				"parameters/openGlobalLoading",
				{
					showLoadingGlobal: true,
					text: "Imprimindo relatório",
					indeterminate: true,
				},
				{ root: true }
			);

			let payload = await this._vm.$axios
				.post(
					"/Representative/Representative/PrintReportInvoicingRanking",
					params
				)
				.then((response) => {
					let relatPath = Utils.ValidateAxiosResponse(response.data);

					if (relatPath)
						dispatch("print/openRelatsPath", [relatPath], {
							root: true,
						});

					return true;
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return false;
				});
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true }
			);

			return payload;
		},
		async listPassengers({ dispatch }, { date, cf6repres }) {
			return await this._vm.$axios
				.get(
					`/Representative/IntegrationRepresentative/ListPassengers?date=${date}&cf6repres=${cf6repres}`
				)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
		addRegion({ commit, getters }, region) {
			let lstCf9 = getters.getCf6.lstCf9 ?? [];
			lstCf9.push(region);
			commit("setRegion", lstCf9);
		},
		removeRegion({ commit }, lstCf9) {
			commit("setRegion", lstCf9);
		},
		setSearch({ commit }, search) {
			commit("setSearch", search);
		},
		setLoading({ commit }, loading) {
			commit("setLoading", loading);
		},
		setCf6({ commit }, cf6) {
			commit("setCf6", cf6);
		},
		setInsert({ commit }, insert) {
			commit("setInsert", insert);
		},
	},
	getters: {
		getCf6: (state) => {
			return state.cf6;
		},
		getLstCf6: (state) => {
			return state.lstCf6;
		},
		getInsert: (state) => {
			return state.insert;
		},
		getUpdate: (state) => {
			return state.update;
		},
		getLoading: (state) => {
			return state.loading;
		},
		getItemsPerPage: (state) => {
			return state.itemsPerPage;
		},
		getSearch: (state) => {
			return state.search;
		},
		getHasNext: (state) => {
			return state.hasNext;
		},
	},
	mutations: {
		initForm(state) {
			state.insert = false;
			state.update = false;
			state.cf6 = null;
		},
		setRegion(state, region) {
			state.cf6.lstCf9 = region;
		},
		setSearch(state, search) {
			state.search = search;
		},
		setCf6(state, cf6) {
			state.cf6 = cf6;
			if (cf6) state.update = true;
		},
		setLoading(state, loading) {
			state.loading = loading;
		},
		setInsert(state, insert) {
			state.insert = insert;
		},
		setParamsDataTable(state, payload) {
			state.lstCf6 = payload.items;
			state.itemsPerPage = payload.limit;
			state.hasNext = payload.hasNext;
		},
		setCf6naoalt(state, cf6naoalt) {
			state.cf6.cf6naoalt = cf6naoalt;
		},
	},
};
